const Check = ({ stroke = "currentColor", ...p }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
    {...p}
  >
    <path
      d="M2.5 6.5l2.5 2.5 5-5.5"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Check;
